import { CONSTANTS } from 'src/app/core/constants/constants';
import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class FlexJointFields {
  public static controls = {
    title: {
      quantity: null,
      validator: TERMS.NAMES_VALIDATORS,
    },
    drawing: {
      quantity: null,
      validator: null,
    },
    revision: {
      quantity: null,
      validator: null,
    },
    stiffTranslational: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    stiffTorsional: {
      quantity: UnitConstants.QUANTITY.TORSIONAL_STIFFNESS,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    stiffBending: {
      quantity: UnitConstants.QUANTITY.TORSIONAL_STIFFNESS,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    numberOfFunctionPoints: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
  };

  public static controlsFunctionRows = {
    rowNumber: {
      quantity: null,
      validator: null,
      type: null,
      pastable: false,
      visible: true,
      readonly: true,
    },
    angle: {
      quantity: UnitConstants.QUANTITY.ANGLE,
      validator: TERMS.REQUIRED_SCI_NOTATION,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
    value: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION,
      type: CONSTANTS.FIELD_TYPES.INPUT,
      pastable: true,
      visible: true,
      readonly: false,
    },
  };

  public static segmentTable = [
    { title: '' },
    {
      title: 'Angle',
      quantity: UnitConstants.QUANTITY.ANGLE,
      visibleDropdown: false,
      currentUnit: UnitConstants.DEFAULT.ANGLE,
      relatedField: 'angle',
    },
    { title: 'VALUE' },
  ];
}
